import Grid from '../../components/common/grid';
import List from '../../components/common/list';
import { Container } from '../../components/layout/container';
import Layout from '../../components/layout/layout';
import { search } from '../../lib/api';
import { enhancePostPreview } from '../../lib/custom-type';
import { useTranslation } from '../../lib/i18n';

export default function BlogDetail({ items, preview }) {
  const { t } = useTranslation();
  return (
    <Layout
      preview={preview}
      title={t('blogTitle')}
      className='bg-green-gradient-1'
    >
      <Container className='pt-4'>
        <div className='cmsRichText my-8'>
          <h1>{t('blogTitle')}</h1>
          <p>{t('bloglead')}</p>
        </div>
        <List listName={'blog'} items={items} Wrapper={Grid}></List>
      </Container>
    </Layout>
  );
}

export async function getStaticProps({ preview = false }) {
  const data = {
    items: (await search(`filter=categories--blog&sort=published--desc`))
      .results,
  };

  data.items.forEach((post) => enhancePostPreview(post));

  return {
    props: {
      ...data,
      preview,
    },
  };
}
